// Service-specific media: photo galleries and optional videos.
// Add an entry per service key; pages will only render the section
// if there is media defined.
export const SERVICE_MEDIA = {
  boxing: {
    headline: "Twinstars Boxing Promotions",
    subhead: "Championship nights. Title belts. Live in the arena.",
    photos: [
      {
        url: "https://customer-assets.emergentagent.com/job_twinstars-demo/artifacts/qd7gn0c8_IMG_7209.jpeg",
        caption: "Quaye crowned — corner team and management ringside.",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_twinstars-demo/artifacts/bbk1qz4m_IMG_7210.jpeg",
        caption: "Belt up — the new champion with his cornermen.",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_twinstars-demo/artifacts/g1s5wr0g_IMG_7211.jpeg",
        caption: "Ringside ceremony — moments after the final bell.",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_twinstars-demo/artifacts/y73iflp3_IMG_7212.jpeg",
        caption: "Belt presentation by Ghana Boxing Authority officials.",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_twinstars-demo/artifacts/45anpc80_IMG_7213.jpeg",
        caption: "Hand raised. Samuel Quaye — Twinstars Boxing Promotions.",
      },
    ],
    // To add a video later, drop one of:
    //   videoYoutube: "https://www.youtube.com/embed/<id>"
    //   videoUrl: "/twinstars-boxing.mp4"     (file in /public)
    videos: [
      {
        url: "https://customer-assets.emergentagent.com/job_twinstars-demo/artifacts/fqzbsttp_15defdb3-dc3e-42a1-8cc3-53ffdbaab563.mp4",
        caption: "Round-by-round highlights — Twinstars Promotions",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_twinstars-demo/artifacts/qfnn66mn_5e15b7d5-598f-4985-87f3-2dfc220522e5.mp4",
        caption: "Championship night — full coverage",
      },
    ],
  },
};
